import { Injectable, OnInit, Injector } from '@angular/core';
import { ParserService } from '../ws/ws.service';
import { environment } from '../../../../environments/environment';
import { ISessionParser } from './session-parser';
import { ISessionManager } from './session-manager';
import { WsService2 } from '../ws/ws.service';
import { WbService } from '../../wb.service';

@Injectable()
export class SessionParserService extends ParserService implements ISessionParser {
    constructor(ws: WsService2, private wbService: WbService) {
        super(ws);
    }
    setSessionManager(r: ISessionManager) {
        this.sessionManager = r;
    }
    sessionManager: ISessionManager
    parseMessage(m) {
        switch (m.cmd) {
            case "showsession": this.onSession(m); break;
            case "showpage": this.onPage(m); break;
            case "showstate": this.onState(m); break;
            case "sessions": this.onSessions(m); break;
            case "showfile": this.onShowFile(m); break;
        }
    }
    onShowFile(m){
        this.wbService.showFile(m);
    }
    onJoin() {
        this.send("join");
    }
    onSession(m) {
        console.log(m.session)
        this.sessionManager.onSession(m.session);
    }
    onPage(m) {
        this.sessionManager.onPage(m.page);
    }
    onState(m){
        this.sessionManager.onState(JSON.parse(m.state.serialized), m.state.pageId);
    }
    getSession(id){
        this.send("getSession", {id: id});
    }
    createSession(s){

        this.send("createSession", s);
    }
    getPage(id){
         this.send("getPage", {id: id});
    }
    createPage(column, boardId, wbType, current){
        this.send("createPage", {"column": column, "boardId":boardId, "wbType":wbType, "current": false});
    }
    sendState(s){
        this.send("setState", s);
    }
    sendCurrentState(state, board){
         this.send("setCurrentState", {currentState: state, id: board.pageId});
    }
    
    getSessions(){
        this.send("getSessions");
    }
    onSessions(m){
        this.sessionManager.onSessions(m.sessions);
    }
    changeDesk(column, boardId, wbType){
        this.send("changeDesk", {"column": column, "boardId":boardId, "wbType":wbType});
       
    }
    sendGroupSelected(group){
        this.send("groupSelected", {groupId: group.id});
    }
    sendExitFromGroup(){
        this.send("groupExit");
    }
    onDisconnected(){
        this.sessionManager.onDisconnected();
    }
}



// WEBPACK FOOTER //
// /app/src/app/wb/services/session/session-parser.service.ts